import { render, staticRenderFns } from "./transportationModelEdit.vue?vue&type=template&id=57e4a6a3&scoped=true"
import script from "./transportationModelEdit.vue?vue&type=script&lang=js"
export * from "./transportationModelEdit.vue?vue&type=script&lang=js"
import style0 from "./transportationModelEdit.vue?vue&type=style&index=0&id=57e4a6a3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4a6a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e4a6a3')) {
      api.createRecord('57e4a6a3', component.options)
    } else {
      api.reload('57e4a6a3', component.options)
    }
    module.hot.accept("./transportationModelEdit.vue?vue&type=template&id=57e4a6a3&scoped=true", function () {
      api.rerender('57e4a6a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/transportationModel/transportationModelEdit.vue"
export default component.exports